import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  Divider,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Fab,
  DialogActions,
  Tooltip,
  Typography,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";
import UploadFileSection from "../UploadFileSection";
import ButtonUpload from "../ButtonUpload";
import ButtonCreate from "../ButtonCreate";
import SelectConNote from "./SelectConNote";
import { UserDataContext } from "../../Contexts/UserDataContext";
import { roles, invoiceStatuses } from "../../Mappings";
import { getDateFromWeekAndDay } from "../../GlobalFunctions";
import AssignBranchInputComponent from "./AssignBranchInputComponent";
const axios = require("axios");

const CreateHourly = (props) => {
  const { truckId, week, day, ...others } = props;
  const [open, setOpen] = useState(false);
  const [filterExpression, setFilterExpression] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [files, setFiles] = useState([]);
  const {
    createHourlyModel,
    blankHourly,
    comments,
    requiredColumns,
  } = useContext(HourlyDataContext);
  const hourlyModel = createHourlyModel({ week, day });
  const displayColumns = [
    "startTimeString",
    "endTimeString",
    "hourlyRate",
    comments,
  ];
  const calculatedColumns = ["totalHours", "totalCharge"];
  const [formData, setFormData] = useState(blankHourly);
  const { userData } = useContext(UserDataContext);
  const disabled =
    !(
      userData.invoiceStatuses[props.truckId][props.week] ===
        invoiceStatuses.unsubmitted ||
      userData.invoiceStatuses[props.truckId][props.week] ===
        invoiceStatuses.dpcPending
    ) || userData.roleId === roles.tollManager;
  const [conNoteList, setConNoteList] = useState([]);

  useEffect(() => {
    // fetch con note list
    const fetchConNoteList = async () => {
      try {
        const res = await axios({
          method: "GET",
          url: `rates/getConsignments/${truckId}/${
            getDateFromWeekAndDay(week, day).dateIsoString
          }`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${userData.token}`,
          },
        });
        setConNoteList(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchConNoteList();
  }, []);

  const handleChange = (name, value) => {
    const newFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(newFormData);
  };

  useEffect(() => {
    const reg = new RegExp(filterExpression.toLowerCase());
    setFilteredList(
      conNoteList.filter((conNote) =>
        reg.test(conNote.conNoteNum.toLowerCase())
      )
    );
  }, [conNoteList, filterExpression]);

  const handleClose = () => {
    setOpen(false);
    setFormData(blankHourly);
    setFiles([]);
  };

  return (
    <>
      <Tooltip title="Create">
        <div>
          <Fab
            disabled={disabled}
            onClick={() => {
              setOpen(true);
            }}
            color="primary"
          >
            <AddIcon />
          </Fab>
        </div>
      </Tooltip>

      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        scroll="body"
      >
        <DialogTitle>Create Hourly</DialogTitle>
        <Divider />
        <DialogContent>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="stretch"
            spacing={1}
          >
            {displayColumns.map((col) => (
              <React.Fragment key={col}>
                <Grid item xs={3}>
                  <Typography>{hourlyModel[col].displayName}</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={formData[col]}
                    onChange={(event) =>
                      handleChange(event.target.name, event.target.value)
                    }
                    error={!hourlyModel[col].validate(formData)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...hourlyModel[col].textFieldProps}
                  />
                </Grid>
              </React.Fragment>
            ))}
            {calculatedColumns.map((col) => (
              <React.Fragment key={col}>
                <Grid item xs={3}>
                  <Typography>{hourlyModel[col].displayName}</Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={hourlyModel[col].displayValue(formData)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...hourlyModel[col].textFieldProps}
                  />
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </DialogContent>
        <Divider />
        <SelectConNote
          conNoteList={conNoteList}
          selectedList={formData.changedRateCons}
          setSelectedList={(newList) =>
            handleChange("changedRateCons", newList)
          }
        />
        {userData.roleId === roles.tollAdmin && (
          <DialogContent>
            <AssignBranchInputComponent
              week={week}
              value={formData.changedRateAssignedBranches}
              setValue={(value) =>
                handleChange("changedRateAssignedBranches", value)
              }
            />
          </DialogContent>
        )}
        <UploadFileSection files={files} setFiles={setFiles} />
        <Divider />
        <DialogActions>
          <ButtonUpload
            // disabled={loading}
            color="primary"
            variant="contained"
            maxFileSize={10000000}
            accept={[".png", ".jpg", ".pdf", ".docx", ".xlsx", ".csv"]}
            multiple={false}
            files={files}
            setFiles={setFiles}
          >
            Browse
          </ButtonUpload>
          <ButtonCreate
            disabled={
              requiredColumns
                .map((col) => hourlyModel[col].validate(formData))
                .includes(false) || files.length === 0
            }
            variant="contained"
            color="primary"
            controller="rates"
            truckId={truckId}
            week={week}
            day={day}
            itemData={{
              driverComments: "",
              adminComments: "",
              managerComments: "",
              ...[
                ...displayColumns,
                "changedRateCons",
                "startTime",
                "endTime",
                ...requiredColumns,
                "totalCharge",
              ].reduce((acc, col) => {
                acc[col] = hourlyModel[col].mapToRequestValue(formData);
                return acc;
              }, {}),
            }}
            files={files}
            callback={handleClose}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateHourly;
